import { createContext } from 'react';

export const TableCursorScrollContext = createContext(false);
